export default __webpack_public_path__ + "static/media/LOGO_NOVO_TARENTO.f914984c.bmp";